module.exports = __webpack_public_path__ + "static/media/doordash.f08c6b6f.png";